import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import App from './App';
import { theme } from './theme';
import './i18n/config';

// Initialize Stripe
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

if (!publishableKey) {
  console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set!');
} else {
  console.log('Stripe publishable key found:', publishableKey.substring(0, 12) + '...');
}

// Keep the promise simple - don't chain .then() as it can cause issues with Elements
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={5000}
        >
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
